import { RedoFulfillmentToteSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-tote";
import * as z from "zod";

export const getTotesByIds = {
  name: "getTotesByIds" as const,
  input: z.object({ toteIds: z.array(z.string()) }),
  output: z.object({ totes: z.array(RedoFulfillmentToteSchema) }),
};
